module.exports = __webpack_public_path__ + "std/img/service-link.5126e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/service-link.png
// module id = EPJ7
// module chunks = 0 1